<script>

    import {PostRequestWithBody, SendRequest} from "./APIService";
    import {UserData} from "./UserStore";
    import {showModal} from "./Modal";
    import moment from "moment/moment";


    let privateUserNews = {};

    let privateNewsToCreate = {
        Data : {},
        ExpireAt : new Date()
    };

    let newsTypes = [
        ["Ban" , 0],
        ["TournamentLeaderboard" , 1],
        ["Warning" , 2],
        ["Custom" , 3]
    ]

    let newsTypesWithTitleAndDescription = [
        findTypeById(0),
        findTypeById(1),
        findTypeById(2),
        findTypeById(3),
    ]

    let newsPriority = [
        ["High", 0],
        ["Low", 1],
    ]

    function findTypeById(id){
        for (let i = 0; i < newsTypes.length; i++) {
            if (newsTypes[i][1] == id)
                return newsTypes[i][0];
        }
    }

    function findPriorityById(id){
        for (let i = 0; i < newsPriority.length; i++) {
            if (newsPriority[i][1] == id)
                return newsPriority[i][0];
        }
    }


    function createPrivateNews(){

        // convert time to UTC
        var date = new Date(privateNewsToCreate.ExpireAt);
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),
            date.getUTCDate(), date.getUTCHours(),
            date.getUTCMinutes(), date.getUTCSeconds());

        privateNewsToCreate.ExpireAt = new Date(now_utc);

        privateNewsToCreate.UserId = $UserData.id;

        PostRequestWithBody(
            "AddPrivateNews",
            "POST",
            privateNewsToCreate,
            (response) => {
                showModal("Success", "private user news created", "OK");
                privateNewsToCreate = { Data : {}, ExpireAt : new Date() };
                getUserPrivateNews();
            },
            (error) => {
                showModal("Error", "failed to create private user news", "OK");
            }
        );
    }

    function deletePrivateNews(id){
        SendRequest(
            "DeletePrivateNews",
            "POST",
            "userId=" + $UserData.id + "&viewId=" + id,
            (response) => {
                console.log("private news deleted");
                privateUserNews = privateUserNews.filter(function (news){
                    news.ViewId != id;
                })
                getUserPrivateNews();
            },
            (error) => {
                showModal("Error", "failed to delete private user news", "OK");
            }
        );
    }

    function getUserPrivateNews(){
        SendRequest("GetAllPrivateNewsByUserId", 'GET',
            "userId=" + $UserData.id, (data) => {
                if(data.news){
                    privateUserNews = data.news;
                }
                else{
                    privateUserNews = {};
                }
            });
    }

    $: privateNewsToCreate;
    $: privateUserNews;

</script>


<br>
<br>
<br>
    <div class="card col-md-12">
        <div class="card-header">
            <h5 class="card-header" style="text-align: center;"><h3>Private User News</h3></h5>
        </div>
        <div class="card-body">
            <div class="mb-3 row">
                <button class="btn btn-outline-primary" type="button" on:click={getUserPrivateNews}>Reload</button>
            </div>
        </div>
        <div class="card-body">
            {#if privateUserNews.length > 0 }
                <table class="table table-bordered table-hover">
                    <thead>
                    <tr>
                        <th style="width: 100px" scope="col">Id</th>
                        <th scope="col">News</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each privateUserNews as prop, index}
                        <tr>
                            <!-- <th scope="row">1</th> -->
                            <td style="text-align: center;">
                                {prop.viewId}
                                <br>
                                <button class="btn btn-danger" type="button" on:click={deletePrivateNews(prop.viewId)}>Delete</button>
                            </td>
                            <td>
                                <table class="table table-bordered table-hover">
                                    <tbody>
                                    {#each Object.entries(prop) as item, index2}
                                        {#if item[0] === "viewId"}

                                        {:else if item[0] == "data" && item[1]}
                                            <tr>
                                                <td> Message : {item[1].Message} </td>
                                            </tr>
                                        {:else if item[0] == "newsType"}
                                            <tr>
                                                <td> {item[0]} : { findTypeById(item[1])} </td>
                                            </tr>
                                        {:else if item[0] == "newsPriority"}
                                            <tr>
                                                <td> {item[0]} : { findPriorityById(item[1])} </td>
                                            </tr>
                                        {:else if item[0] == "expireAt"}
                                            <tr>
                                                <td> {item[0]} : { moment(new Date(item[1])).from(new Date())} </td>
                                            </tr>
                                        {:else if item[0] == "createdAt"}
                                            <tr>
                                                <td> {item[0]} : { moment(new Date(item[1])).from(new Date())} </td>
                                            </tr>
                                        {:else}
                                            <tr>
                                                <td> {item[0]} : {item[1]} </td>
                                            </tr>
                                        {/if}
                                    {/each}
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {/if}
        </div>
    </div>

<hr>

<!-- Create Private News -->
<div class="card col-md-12">
    <h5 class="card-header" style="text-align: center;"><h3>Create Private News</h3></h5>

    <div class="card-body">

        <div class="mb-3 input-group">
            <label  class="col-2 col-form-label">NewsType</label>
            <select class="custom-select form-select" id="inputGroupSelect01" bind:value={privateNewsToCreate.NewsType}>
                {#each newsTypes as type, index}
                    {#if index == 1}
                        <option selected value="{type[1]}" >{type[0]}</option>
                    {:else}
                        <option value="{type[1]}" >{type[0]}</option>
                    {/if}
                {/each}
            </select>
        </div>

        {#if newsTypesWithTitleAndDescription.includes(findTypeById(privateNewsToCreate.NewsType)) }
            <div class="mb-3 input-group">
                <label  class="col-2 col-form-label">Title</label>
                <input type="text" class="form-control" placeholder="Title" bind:value={privateNewsToCreate.Title}>
            </div>
            <div class="mb-3 input-group">
                <label  class="col-2 col-form-label">Description</label>
                <textarea class="form-control" rows="3" bind:value={privateNewsToCreate.Description}></textarea>
            </div>
        {/if}

        <div class="input-group mb-3">
            <label  class="col-2 col-form-label">ImageURL</label>
            <input type="text" class="form-control" placeholder="ImageURL" bind:value={privateNewsToCreate.ImageURL}>
        </div>
        <div class="mb-3 input-group">
            <label  class="col-2 col-form-label">VideoURL</label>
            <input type="text" class="form-control" placeholder="VideoURL" bind:value={privateNewsToCreate.VideoURL}>
        </div>
        <div class="mb-3 input-group">
            <label  class="col-2 col-form-label">ExternalLinkURL</label>
            <input type="text" class="form-control" placeholder="ExternalLinkURL" bind:value={privateNewsToCreate.ExternalLinkURL}>
        </div>
        <div class="mb-3 input-group">
            <label  class="col-2 col-form-label">BuildVersionLimit</label>
            <input type="text" class="form-control" placeholder="BuildVersionLimit" bind:value={privateNewsToCreate.BuildVersionLimit}>
        </div>
        <div class="mb-3 input-group">
            <label  class="col-2 col-form-label">NewsPriority</label>
            <select class="custom-select form-select" id="inputGroupSelect02" bind:value={privateNewsToCreate.NewsPriority}>
                {#each newsPriority as prority, index}
                    {#if index == 1}
                        <option selected value="{prority[1]}" >{prority[0]}</option>
                    {:else}
                        <option value="{prority[1]}" >{prority[0]}</option>
                    {/if}
                {/each}

            </select>
        </div>
        <div class="mb-3 input-group">
            <label  class="col-2 col-form-label">ExpireAt</label>
            <input type="datetime-local" class="form-control" placeholder="ExpireAt" bind:value={privateNewsToCreate.ExpireAt}>
        </div>
        <div class="mb-3 input-group">
            <label  class="col-2 col-form-label">Message</label>
            <input type="text" class="form-control" placeholder="Data" bind:value={privateNewsToCreate.Data.Message}>
        </div>


        <div class="mb-3 input-group">
            <button class="btn btn-danger" type="button" on:click={createPrivateNews}>Create</button>
        </div>



    </div>
</div>

<br>
<br>
<br>
<hr>

<style>

    .card{
        margin: 5px;
    }

    td
    {
        vertical-align: middle;
    }

</style>